import React, { useContext } from "react";
import { AuthContext } from "../context/AuthContext";
import { tsToMillis } from "../Utils/firebase";

function VisitorChart() {
  const { visitor } = useContext(AuthContext);

  const date = (xtime) => {
    let newTime = new Date();
    let time = newTime.getTime() - xtime * (24 * 60 * 60 * 1000);
    let dateTime = new Date(time);
    let month = ("0" + (dateTime.getMonth() + 1)).slice(-2);
    let date = dateTime.getDate();
    return date + " / " + month;
  };

  const getMaxNumber = () => {
    if (visitor !== null) {
      const compareDate = new Date(tsToMillis - 3 * (24 * 60 * 60 * 1000));

      const newFour = visitor.filter(
        (vis) => vis.visit_at.toDate().getTime() >= compareDate.getTime()
      );
      return newFour.length;
    } else {
      return 100;
    }
  };

  const getVisitorValue = (val) => {
    if (visitor !== null) {
      const newTime = new Date();
      const time = newTime.getTime() - val * (24 * 60 * 60 * 1000);
      const getDate = new Date(time);
      const newVisit = visitor.filter(
        (vis) =>
          vis.visit_at.toDate().toLocaleDateString() ===
          getDate.toLocaleDateString()
      );
      return newVisit.length;
    } else {
      return 0;
    }
  };

  const getVisitorNumber = (val) => {
    if (visitor !== null) {
      const newTime = new Date();
      const time = newTime.getTime() - val * (24 * 60 * 60 * 1000);
      const getDate = new Date(time);
      const newVisit = visitor.filter(
        (vis) =>
          vis.visit_at.toDate().toLocaleDateString() ===
          getDate.toLocaleDateString()
      );
      if (newVisit.length > 1) {
        return newVisit.length + " Visitors";
      } else {
        return newVisit.length + " Visitor";
      }
    } else {
      return "0 Visitor";
    }
  };

  return (
    <div className="visitor-chart divContent darktextColor darkdivColor">
      <div className="head-tab">
        <h5 className="textTitle textMedium">Chart</h5>
        <p className="textSmall textMedium">last 4 days</p>
      </div>
      <div className="chart-box">
        <div className="chart-line">
          <div className="line-head">
            <h4>Today</h4>
            <p className="text">{getVisitorNumber(0)}</p>
          </div>
          <progress
            className="bar"
            value={getVisitorValue(0)}
            max={getMaxNumber()}
            min="0"
          ></progress>
        </div>
        <div className="chart-line">
          <div className="line-head">
            <h4>{date(1)}</h4>
            <p className="text">{getVisitorNumber(1)}</p>
          </div>
          <progress
            className="bar"
            value={getVisitorValue(1)}
            max={getMaxNumber()}
            min="0"
          ></progress>
        </div>
        <div className="chart-line">
          <div className="line-head">
            <h4>{date(2)}</h4>
            <p className="text">{getVisitorNumber(2)}</p>
          </div>
          <progress
            className="bar"
            value={getVisitorValue(2)}
            max={getMaxNumber()}
            min="0"
          ></progress>
        </div>
        <div className="chart-line">
          <div className="line-head">
            <h4>{date(3)}</h4>
            <p className="text">{getVisitorNumber(3)}</p>
          </div>
          <progress
            className="bar"
            value={getVisitorValue(3)}
            max={getMaxNumber()}
            min="0"
          ></progress>
        </div>
      </div>
    </div>
  );
}

export default VisitorChart;
